import { C_ACCOUNT } from '_acaSrc/utility/constants';

export default class MergeResultHandler {
    static createSuccessResult() {
        return {
            success: true,
            message: {
                type: C_ACCOUNT.MESSAGE_TYPE.SUCCESS,
                title: C_ACCOUNT.FORM_MESSAGING.MERGE_SUCCESS_TITLE,
                content: C_ACCOUNT.FORM_MESSAGING.MERGE_SUCCESS_MESSAGE
            }
        };
    }

    static createErrorResult() {
        return {
            success: false,
            message: {
                type: C_ACCOUNT.MESSAGE_TYPE.ERROR,
                title: C_ACCOUNT.FORM_MESSAGING.MERGE_DEFAULT_TITLE,
                content: C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_MESSAGE
                    + C_ACCOUNT.FORM_MESSAGING.CANNOT_MERGE_CONTACT
            }
        };
    }
}
